/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, spacing, typography } from '../../theme/public-api';

type Props = {
  caption: string;
  /** Nombre visible del ítem fijado (o fallback). */
  productLabel: string;
  disabled?: boolean;
  onClear: () => void;
};

/**
 * Misma línea compacta que Informes › Ventas al fijar un producto desde el buscador.
 */
export const ProductSearchPinnedChip = ({ caption, productLabel, disabled, onClear }: Props) => (
  <View
    style={{
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing.sm,
      marginTop: spacing.xs,
      paddingVertical: spacing.xs + 2,
      paddingHorizontal: spacing.sm,
      borderRadius: 10,
      backgroundColor: colors.controlSurface,
      borderWidth: 1,
      borderColor: colors.controlBorder,
    }}
  >
    <View style={{ flex: 1, minWidth: 0 }}>
      <Text style={[typography.caption, { color: colors.textMuted }]} numberOfLines={1}>
        {caption}
      </Text>
      <Text style={{ fontWeight: '600', color: colors.textPrimary }} numberOfLines={2}>
        {productLabel}
      </Text>
    </View>
    <TouchableOpacity
      onPress={onClear}
      disabled={disabled}
      accessibilityRole="button"
      accessibilityLabel="Quitar filtro de producto"
      hitSlop={10}
    >
      <Ionicons name="close-circle" size={24} color={colors.textSecondary} />
    </TouchableOpacity>
  </View>
);
